export const heroSlides = [
  {
    title: '速度与激情10',
    subtitle: '2026年最燃动作巨制',
    desc: '家族再度集结，面对前所未有的危机。极速狂飙，极限追逐，这个夏天最不能错过的电影！',
    rating: '8.5',
    tags: ['动作', '冒险', '犯罪'],
    year: '2026',
    link: '/article/1',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20atmosphere%20with%20dramatic%20lighting%2C%20warm%20orange%20and%20amber%20accents%2C%20abstract%20cinematic%20composition%20with%20film%20grain%20texture%2C%20deep%20shadows%20and%20rich%20contrast%2C%20professional%20movie%20poster%20aesthetic%2C%20dark%20background%20with%20subtle%20light%20rays%20creating%20moody%20atmosphere&width=1920&height=800&seq=hero-bg-0-mh&orientation=landscape',
  },
  {
    title: '流浪地球3',
    subtitle: '科幻史诗终章',
    desc: '人类命运的最后抉择，太阳系之外的未知世界。中国科幻巅峰之作，全球同步上映！',
    rating: '9.1',
    tags: ['科幻', '灾难', '冒险'],
    year: '2026',
    link: '/article/2',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20massive%20spaceship%20in%20deep%20space%2C%20dramatic%20orange%20and%20golden%20nebula%20lighting%2C%20futuristic%20atmosphere%2C%20grand%20scale%20composition%2C%20dark%20cosmic%20background%20with%20brilliant%20warm%20light%20rays%2C%20cinematic%20film%20aesthetic&width=1920&height=800&seq=hero-bg-1-mh&orientation=landscape',
  },
  {
    title: '哪吒之魔童闹海',
    subtitle: '国漫之光归来',
    desc: '天命难违，我命由我不由天。全新篇章，视觉盛宴，带你进入神话世界的终极冒险！',
    rating: '9.3',
    tags: ['动画', '奇幻', '动作'],
    year: '2026',
    link: '/article/3',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20scene%20with%20dragon%20and%20fire%20elements%2C%20dramatic%20warm%20orange%20and%20crimson%20lighting%2C%20cinematic%20composition%20with%20swirling%20flames%2C%20dark%20atmospheric%20background%2C%20animated%20film%20aesthetic%20with%20rich%20texture&width=1920&height=800&seq=hero-bg-2-mh&orientation=landscape',
  },
];

export const hotMovies = [
  {
    id: 1,
    title: '封神第二部',
    category: '奇幻 / 动作',
    rating: '8.8',
    year: '2026',
    desc: '商周大战全面爆发，封神榜即将揭晓最终篇章。',
    link: '/article/4',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20movie%20poster%20style%2C%20cinematic%20dramatic%20lighting%20with%20warm%20orange%20and%20amber%20tones%2C%20film%20poster%20aesthetic%20with%20Chinese%20title%20text%20design%2C%20dark%20moody%20background%2C%20professional%20movie%20promotional%20design%2C%20clean%20composition%20with%20focal%20point&width=400&height=600&seq=hot-movie-01&orientation=portrait',
  },
  {
    id: 2,
    title: '长安三万里2',
    category: '动画 / 历史',
    rating: '8.6',
    year: '2026',
    desc: '盛唐诗篇续写传奇，李白与杜甫的千年之约。',
    link: '/article/5',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20ancient%20Tang%20Dynasty%20aesthetic%2C%20warm%20golden%20tones%2C%20poetic%20atmosphere%2C%20traditional%20Chinese%20art%20style%2C%20dark%20rich%20background%2C%20professional%20film%20design%2C%20elegant%20composition&width=400&height=600&seq=hot-movie-02&orientation=portrait',
  },
  {
    id: 3,
    title: '独行月球2',
    category: '科幻 / 喜剧',
    rating: '8.3',
    year: '2026',
    desc: '月球基地再次遭遇危机，独孤月能否再次创造奇迹？',
    link: '/article/6',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comedy%20movie%20poster%20with%20astronaut%20on%20moon%20surface%2C%20warm%20orange%20and%20golden%20tones%2C%20cinematic%20lighting%2C%20humorous%20yet%20dramatic%20atmosphere%2C%20dark%20space%20background%2C%20clean%20professional%20composition&width=400&height=600&seq=hot-movie-03&orientation=portrait',
  },
  {
    id: 4,
    title: '满江红2',
    category: '悬疑 / 历史',
    rating: '8.1',
    year: '2026',
    desc: '南宋临安，一场更大的阴谋正在浮出水面。',
    link: '/article/7',
    image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20mystery%20movie%20poster%20with%20Song%20Dynasty%20aesthetic%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20dramatic%20lighting%20with%20shadows%2C%20dark%20atmospheric%20background%2C%20professional%20film%20design%2C%20intense%20mood&width=400&height=600&seq=hot-movie-04&orientation=portrait',
  },
  {
    id: 5,
    title: '巨齿鲨3',
    category: '动作 / 科幻',
    rating: '7.9',
    year: '2026',
    desc: '深海巨兽再度来袭，人类面临史前猎食者的终极挑战。',
    link: '/article/8',
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20giant%20shark%20in%20deep%20ocean%2C%20dramatic%20warm%20orange%20and%20teal%20contrast%2C%20cinematic%20lighting%2C%20thrilling%20atmosphere%2C%20dark%20underwater%20background%2C%20professional%20Hollywood%20style%20film%20design&width=400&height=600&seq=hot-movie-05&orientation=portrait',
  },
  {
    id: 6,
    title: '消失的她2',
    category: '悬疑 / 犯罪',
    rating: '8.4',
    year: '2026',
    desc: '新的谜案，更深的人性考验，真相远比想象中更加残酷。',
    link: '/article/9',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%2C%20dark%20atmospheric%20design%20with%20warm%20amber%20accents%2C%20suspenseful%20mood%2C%20shadows%20and%20silhouettes%2C%20professional%20film%20aesthetic%2C%20clean%20composition%2C%20rich%20textured%20background&width=400&height=600&seq=hot-movie-06&orientation=portrait',
  },
];

export const categories = [
  {
    slug: 'movie',
    name: '电影',
    icon: 'ri-film-line',
    desc: '院线大片 · 经典佳作 · 高分必看',
    count: '12,680+',
    link: '/category/movie',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20scene%20with%20film%20projector%20beam%20of%20light%2C%20warm%20golden%20and%20amber%20tones%2C%20classic%20cinema%20aesthetic%2C%20dramatic%20shadows%2C%20vintage%20movie%20reel%20atmosphere%2C%20rich%20textured%20background%20with%20soft%20bokeh&width=600&height=400&seq=cat-movie&orientation=landscape',
  },
  {
    slug: 'tv',
    name: '电视剧',
    icon: 'ri-tv-line',
    desc: '热播剧集 · 高分国剧 · 海外精选',
    count: '8,520+',
    link: '/category/tv',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cozy%20living%20room%20with%20large%20TV%20screen%20displaying%20dramatic%20scene%2C%20warm%20ambient%20lighting%2C%20comfortable%20sofa%2C%20evening%20atmosphere%20with%20soft%20golden%20glow%2C%20home%20cinema%20aesthetic%2C%20crisp%20detailed%20composition&width=600&height=400&seq=cat-tv&orientation=landscape',
  },
  {
    slug: 'variety',
    name: '综艺',
    icon: 'ri-live-line',
    desc: '热门综艺 · 搞笑娱乐 · 真人秀场',
    count: '5,340+',
    link: '/category/variety',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20TV%20studio%20stage%20with%20colorful%20dynamic%20lighting%2C%20entertainment%20show%20atmosphere%2C%20warm%20spotlights%20with%20amber%20and%20coral%20tones%2C%20professional%20broadcast%20set%20design%2C%20lively%20energetic%20composition%2C%20rich%20textured%20background&width=600&height=400&seq=cat-variety&orientation=landscape',
  },
  {
    slug: 'anime',
    name: '动漫',
    icon: 'ri-rocket-line',
    desc: '国漫崛起 · 日漫经典 · 剧场版',
    count: '9,870+',
    link: '/category/anime',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20illustration%20with%20warm%20golden%20and%20amber%20color%20palette%2C%20dreamy%20atmospheric%20scene%20with%20soft%20glowing%20particles%2C%20cinematic%20lighting%2C%20beautiful%20detailed%20background%20with%20rich%20texture%2C%20fantasy%20aesthetic&width=600&height=400&seq=cat-anime&orientation=landscape',
  },
];

export const latestUpdates = [
  {
    id: 10,
    title: '庆余年3',
    category: '古装 / 权谋',
    episode: '更新至16集',
    rating: '9.0',
    updateTime: '今天 20:00',
    link: '/article/10',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20style%2C%20warm%20golden%20and%20amber%20tones%2C%20ancient%20Chinese%20palace%20aesthetic%2C%20cinematic%20lighting%2C%20dark%20rich%20background%2C%20professional%20film%20design%2C%20elegant%20composition&width=200&height=280&seq=latest-01&orientation=portrait',
  },
  {
    id: 11,
    title: '狂飙2',
    category: '犯罪 / 剧情',
    episode: '更新至28集',
    rating: '8.7',
    updateTime: '今天 19:30',
    link: '/article/11',
    image: 'https://readdy.ai/api/search-image?query=Crime%20drama%20TV%20series%20poster%2C%20dark%20intense%20atmosphere%20with%20warm%20amber%20accents%2C%20noir%20style%20lighting%2C%20suspenseful%20mood%2C%20professional%20design%2C%20rich%20textured%20background%2C%20clean%20composition&width=200&height=280&seq=latest-02&orientation=portrait',
  },
  {
    id: 12,
    title: '三体：黑暗森林',
    category: '科幻 / 悬疑',
    episode: '更新至8集',
    rating: '9.2',
    updateTime: '今天 18:00',
    link: '/article/12',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20poster%20with%20cosmic%20theme%2C%20deep%20space%20and%20stars%2C%20warm%20orange%20and%20golden%20nebula%20tones%2C%20mysterious%20atmosphere%2C%20dark%20cosmic%20background%2C%20professional%20film%20design%2C%20clean%20composition&width=200&height=280&seq=latest-03&orientation=portrait',
  },
  {
    id: 13,
    title: '奔跑吧第12季',
    category: '真人秀 / 娱乐',
    episode: '更新至第5期',
    rating: '7.8',
    updateTime: '昨天 22:00',
    link: '/article/13',
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20poster%20with%20vibrant%20energetic%20colors%2C%20warm%20coral%20and%20amber%20tones%2C%20fun%20dynamic%20atmosphere%2C%20entertainment%20TV%20aesthetic%2C%20bright%20studio%20lighting%2C%20clean%20professional%20design&width=200&height=280&seq=latest-04&orientation=portrait',
  },
  {
    id: 14,
    title: '仙逆',
    category: '玄幻 / 动画',
    episode: '更新至42集',
    rating: '8.9',
    updateTime: '昨天 20:00',
    link: '/article/14',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20animation%20poster%20with%20fantasy%20cultivation%20theme%2C%20warm%20golden%20and%20crimson%20tones%2C%20ethereal%20atmosphere%20with%20glowing%20effects%2C%20dark%20mystical%20background%2C%20professional%20anime%20style%20design&width=200&height=280&seq=latest-05&orientation=portrait',
  },
  {
    id: 15,
    title: '大江大河3',
    category: '剧情 / 年代',
    episode: '全36集',
    rating: '9.1',
    updateTime: '昨天 17:00',
    link: '/article/15',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20with%20reform%20era%20aesthetic%2C%20warm%20nostalgic%20tones%2C%20golden%20amber%20lighting%2C%20historical%20Chinese%20atmosphere%2C%20dark%20rich%20background%2C%20professional%20film%20design%2C%20clean%20composition&width=200&height=280&seq=latest-06&orientation=portrait',
  },
];

export const faqItems = [
  {
    q: '麻花影视需要付费吗？',
    a: '麻花影视完全免费！我们聚合飘花电影网、555电影、8090电影网等优质高清电影资源，所有电影、电视剧、综艺节目均可免费在线观看，无需注册，无需付费。',
  },
  {
    q: '播放视频会卡顿或缓冲吗？',
    a: '麻花影视采用先进的CDN加速技术，整合多线路播放源，确保高清影视内容流畅播放。我们持续优化服务器网络，让您享受丝滑观影体验，真正做到不缓冲。',
  },
  {
    q: '可以在手机和平板上观看吗？',
    a: '当然可以！麻花影视全面适配手机、平板和电脑端，无论您使用什么设备，都能获得优质的观影体验。界面自适应屏幕尺寸，操作简单便捷。',
  },
  {
    q: '片库更新频率如何？',
    a: '我们的片库每日更新，第一时间同步各大平台最新上线的电影和电视剧。无论是刚上映的院线大片，还是最新开播的热门剧集，您都能在麻花影视上找到。',
  },
  {
    q: '如何搜索我想看的电影？',
    a: '您可以使用首页顶部的搜索框输入电影名称或关键词进行搜索，也可以通过分类页面按类型、年份、地区等维度筛选。我们的智能推荐系统也会根据您的观影偏好推送相关内容。',
  },
];

export const siteStats = [
  { label: '影视资源', value: '36,000+' },
  { label: '日更新量', value: '200+' },
  { label: '日均访客', value: '500万+' },
  { label: '高清画质', value: '4K HDR' },
];

export const footerLinks = {
  categories: [
    { label: '动作电影', link: '/category/movie' },
    { label: '热门剧集', link: '/category/tv' },
    { label: '综艺节目', link: '/category/variety' },
    { label: '动漫专区', link: '/category/anime' },
    { label: '高分推荐', link: '/category/movie' },
  ],
  platform: [
    { label: '飘花电影网', link: '/category/movie' },
    { label: '555电影', link: '/category/movie' },
    { label: '8090电影网', link: '/category/movie' },
    { label: '最新电影', link: '/category/movie' },
    { label: '高清影院', link: '/category/movie' },
  ],
  about: [
    { label: '关于我们', link: '/about' },
    { label: '联系我们', link: '/about' },
    { label: '用户协议', link: '/about' },
    { label: '隐私政策', link: '/about' },
    { label: '版权声明', link: '/about' },
  ],
};